<template>
  <MDBCard class="w-100 shadow-3">
    <MDBCardHeader class="fw-bold text-black"
      >Transaction History</MDBCardHeader
    >
    <MDBCardBody class="d-flex flex-column p-0">
      <div class="overflow-auto" id="table-container">
        <MDBTable>
          <thead class="table-light">
            <tr>
              <th scope="col" class="sticky-top">Transaction</th>
              <th scope="col" class="sticky-top">Date Updated</th>
              <th scope="col" class="sticky-top">Status</th>
              <th scope="col" class="sticky-top">Action</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="isLoading">
              <tr>
                <td colspan="4" class="text-center">
                  <div
                    class="image-container d-flex justify-content-center align-items-center"
                  >
                    <div class="loader"></div>
                    <img
                      src="@/assets/VVV/vvv-loader.png"
                      alt="Loading image"
                    />
                  </div>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr v-if="transactionList.data.length === 0 && !isLoading">
                <td colspan="4" class="text-center">No transactions found.</td>
              </tr>
              <template
                v-else
                v-for="(item, i) in transactionList.data"
                :key="i"
              >
                <tr>
                  <td>
                    <template v-if="item.transactionType == 'subscription'">
                      <MDBBadge
                        class="bg-success text-white px-3"
                        style="font-size: 13px"
                      >
                        Early Pay
                        {{ formatTransactionType(item.transactionType) }}
                      </MDBBadge>
                    </template>
                    <template
                      v-else-if="item.transactionType == 'subscription_credit'"
                    >
                      <MDBBadge
                        class="bg-info text-white px-3"
                        style="font-size: 13px"
                      >
                        Early Pay
                        {{ formatTransactionType(item.transactionType) }}
                      </MDBBadge>
                    </template>
                    <template v-else>
                      <MDBBadge
                        class="bg-danger text-white px-3"
                        style="font-size: 13px"
                      >
                        Withdraw</MDBBadge
                      >
                    </template>
                  </td>
                  <th>{{ parseDateLong(item.dateUpdated) }}</th>
                  <td>
                    <template v-if="item.transactionType === 'withdrawal'">
                      <template v-if="item.status == 'Approved'">
                        <MDBBadge
                          class="bg-success text-white px-4"
                          style="font-size: 13px"
                        >
                          Approved</MDBBadge
                        >
                      </template>
                      <template v-else-if="item.status == 'Pending'">
                        <MDBBadge
                          class="bg-warning text-white px-4"
                          style="font-size: 13px"
                        >
                          Pending</MDBBadge
                        >
                      </template>
                      <template v-else>
                        <MDBBadge
                          class="bg-danger text-white px-3"
                          style="font-size: 13px"
                        >
                          Rejected</MDBBadge
                        >
                      </template>
                    </template>
                    <template v-else>
                      <template v-if="item.status == 'Activated'">
                        <MDBBadge
                          class="bg-success text-white px-4"
                          style="font-size: 13px"
                        >
                          Activated</MDBBadge
                        >
                      </template>
                      <template v-else-if="item.status == 'Completed'">
                        <MDBBadge
                          class="bg-primary text-white px-4"
                          style="font-size: 13px"
                        >
                          Completed</MDBBadge
                        >
                      </template>
                      <template v-else-if="item.status == 'Approved'">
                        <MDBBadge
                          class="bg-success text-white px-4"
                          style="font-size: 13px"
                        >
                          Activated</MDBBadge
                        >
                      </template>
                      <template v-else-if="item.status == 'Pending'">
                        <MDBBadge
                          class="bg-warning text-white px-4"
                          style="font-size: 13px"
                        >
                          Pending</MDBBadge
                        >
                      </template>
                      <template v-else-if="item.status == 'Rejected'">
                        <MDBBadge
                          class="bg-danger text-white px-4"
                          style="font-size: 13px"
                        >
                          Rejected</MDBBadge
                        >
                      </template>
                      <template v-else>
                        <MDBBadge
                          class="bg-danger text-white px-3"
                          style="font-size: 13px"
                        >
                          Deactivated</MDBBadge
                        >
                      </template>
                    </template>
                  </td>
                  <td>
                    <MDBTooltip v-model="viewTooltip[i]">
                      <template #reference>
                        <button
                          type="button"
                          @click.stop="fetchSubscriptionDetails(item)"
                          class="btn-md border-0 bg-white primary-text"
                          data-mdb-ripple-init
                          data-mdb-modal-init
                          data-mdb-target="#viewModal"
                        >
                          <i class="fas fa-file-text fa-lg pe-none"></i>
                        </button>
                      </template>
                      <template #tip>View Details</template>
                    </MDBTooltip>
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
        </MDBTable>
      </div>
      <div class="overflow-auto px-3">
        <Paginate
          v-if="
            transactionList.data.length &&
            transactionList.pagination?.totalPages
          "
          :page-count="transactionList.pagination.totalPages"
          :click-handler="handlePage"
          :prev-text="'Previous'"
          :next-text="'Next'"
          :container-class="'pagination'"
          first-last-button
          style="margin-top: 0px; margin-left: unset; overflow: auto"
        />
      </div>
    </MDBCardBody>
  </MDBCard>
  <MDBModal
    id="viewModal"
    tabindex="1"
    labelledby="viewModal"
    v-model="viewModal"
  >
    <template
      v-if="
        subscriptionDetails.transactionType === 'subscription' ||
        subscriptionDetails.transactionType === 'withdrawal'
      "
    >
      <MDBModalHeader class="px-4">
        <MDBModalTitle class="fw-bold" id="viewModal">
          <template
            v-if="subscriptionDetails.transactionType === 'subscription'"
          >
            Subscription
            <span class="primary-text">{{ subscriptionDetails.status }}</span>
          </template>
          <template v-if="subscriptionDetails.transactionType === 'withdrawal'">
            Withdraw Request
            <span class="primary-text">{{ subscriptionDetails.status }}</span>
          </template>
        </MDBModalTitle>
      </MDBModalHeader>
      <MDBModalBody class="p-4" style="max-height: 70vh; overflow: auto">
        <div
          v-if="subscriptionDetails.transactionType === 'withdrawal'"
          class="mb-4"
        >
          <h6>Reference Code</h6>
          <h5 class="fw-bold">{{ subscriptionDetails.referenceCode }}</h5>
          <h6 style="font-size: 14px">
            NOTE: This is the unique reference code for your transaction. Keep
            it handy for any inquires or support related to this transaction.
          </h6>
        </div>
        <div class="border rounded-5 p-4">
          <h6 class="fw-bold mb-3">History Log</h6>
          <div v-if="creditHistory.length > 0" class="position-relative">
            <div
              v-for="(log, index) in sortedCreditHistory"
              :key="log.id"
              class="mb-4 position-relative"
            >
              <span
                class="position-absolute translate-middle rounded-circle"
                style="
                  width: 12px;
                  height: 12px;
                  top: 24%;
                  left: 2%;
                  background-color: var(--primary);
                "
              ></span>

              <div
                v-if="index !== sortedCreditHistory.length - 1"
                class="position-absolute"
                style="
                  top: 30px;
                  bottom: -30px;
                  width: 2px;
                  background-color: #dee2e6;
                  left: 1.8%;
                "
              ></div>

              <div class="ms-4">
                <div class="d-flex justify-content-between">
                  <div class="fw-bold">
                    {{
                      userDetail.id !== log.createdByUserId
                        ? "VVV Admin"
                        : `${log.createdByFullName}`
                    }}
                  </div>
                  <small class="text-muted">
                    {{ new Date(log.dateCreated).toLocaleString() }}
                  </small>
                </div>
                <div>{{ log.remarks }}</div>
                <div class="fs-7">{{ log.referenceCode }}</div>
              </div>
            </div>
          </div>
          <div v-else class="text-center text-muted">No history log found.</div>
        </div>
      </MDBModalBody>
    </template>
    <template v-else>
      <MDBModalHeader class="px-4">
        <MDBModalTitle class="fw-bold" id="viewModal">
          Credit Complete
        </MDBModalTitle>
      </MDBModalHeader>
      <MDBModalBody class="p-4">
        <div>
          <h6>Reference Code</h6>
          <h5 class="fw-bold">{{ subscriptionDetails.referenceCode }}</h5>
          <h6 style="font-size: 14px">
            NOTE: This is the unique reference code for your transaction. Keep
            it handy for any inquires or support related to this transaction.
          </h6>
        </div>
        <div class="border rounded-5 p-4 mt-4">
          <h6>Date Credited</h6>
          <h5 class="fw-bold">
            {{ parseDateLong(subscriptionDetails.dateCreated) }}
          </h5>
          <hr />
          <!-- <div>
                        <h6 class="fw-bold">Early Pay Credit</h6>
                        <div class="d-flex justify-content-between align-items-center">
                            <h6 class="fs-7">Net Revenue</h6>
                            <h6 class="fs-7 fw-bold">$620.58</h6>
                        </div>
                    </div>
                    <hr> -->
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="fs-7">Amount Credited</h6>
            <h6 class="fs-7 fw-bold">
              ${{ addCommaNumbers(subscriptionDetails.amount) }}
            </h6>
          </div>
          <hr />
          <p class="mb-0 fst-italic">
            VeryViralVideos has processed this credit transaction.
          </p>
        </div>
      </MDBModalBody>
    </template>
  </MDBModal>
</template>

<script setup>
import { addCommaNumbers } from "@/helpers/addCommaNumbers";
import { parseDateLong } from "@/helpers/parseDate";
import { useUserDetailStore } from "@/store/userDetailStore";
import {
  MDBBadge,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalTitle,
  MDBTable,
  MDBTooltip,
} from "mdb-vue-ui-kit";
import { storeToRefs } from "pinia";
import { computed, defineProps, ref } from "vue";
import { useRoute } from "vue-router"; // added
import Paginate from "vuejs-paginate-next";
import { GetTransactionById } from "../../../services/TransactionHistory/GetTransactionById";

const userDetailStore = useUserDetailStore();
const { userDetail } = storeToRefs(userDetailStore);
const route = useRoute();//added
defineProps({
  isLoading: Boolean,
  handlePage: Function,
  transactionList: Object,
});

const viewModal = ref(false);
const viewTooltip = ref([]);
const subscriptionDetails = ref({});
const creditHistory = ref([]);
// const fetchSubscriptionDetails = async (data) => {
//   viewModal.value = true;
//   subscriptionDetails.value = data;
//   try {
//     const response = await GetTransactionById(
//       data.transactionId,
//       data.transactionType
//     );

//     if (response) {
//       if (response) {
//         creditHistory.value = response || [];
//       }
//     }
//   } catch (error) {
//     console.error(error);
//   }
// };

const fetchSubscriptionDetails = async (data) => {
  viewModal.value = true;
  subscriptionDetails.value = data;
  
  try {
    // Build additional params object
    const additionalParams = {};
    
    // ✅ ADD THIS: Include impersonation parameters if applicable
    if (route.query.isImpersonation === 'true' && route.query.userId) {
      additionalParams.userId = parseInt(route.query.userId);
      additionalParams.isImpersonation = true;
    }
    
    // Call the service with the three parameters
    const response = await GetTransactionById(
      data.transactionId,
      data.transactionType,
      additionalParams // Pass additional params as third argument
    );

    if (response) {
      creditHistory.value = response || [];
    }
  } catch (error) {
    console.error(error);
  }
};


const sortedCreditHistory = computed(() =>
  creditHistory.value
    .slice()
    .sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated))
);

function formatTransactionType(type) {
  return type
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
</script>

<style scoped>
:root {
  --white: #ffffff;
  --primary: #223698;
  --secondary: #e2e6ef;
  --accent: #02061b;
  --blue: #1f87fc;
  --mdb-primary: var(--primary);
}

.btn-primary {
  background-color: var(--primary);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.btn-outline-primary {
  color: var(--primary);
  border-color: var(--primary);
}

.border-primary {
  border-color: var(--primary);
}

#table-container {
  flex: 1 1 auto;
  max-height: 35vh;
}

.image-container {
  position: relative;
  display: inline-block;
}

.image-container .loader {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 45px;
  height: 45px;
  border: 3px solid rgba(0, 0, 0, 0.1);
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: BorderSpin 1s linear infinite;
}

.image-container img {
  display: block;
  width: 45px;
  height: 45px;
  border-radius: 50%;
}
</style>
